import { Button } from '@eo/shared';
import type { SecurityCardProps } from './types';

export function SecurityCard({ onSignOut }: SecurityCardProps) {
  return (
    <section className="flex flex-1 flex-col gap-10 self-stretch rounded-16 border border-border-faint p-8">
      <h2 className="text-xl text-text-primary">Security</h2>

      <div className="flex flex-col gap-8 sm:flex-row sm:gap-16">
        <div className="flex flex-col items-center gap-4 sm:items-start">
          <span className="w-full text-center text-sm text-text-primary sm:w-auto sm:text-left">
            Password
          </span>
          <span className="max-w-[260px] text-center text-xs text-text-tertiary sm:text-left">
            Sign-in is managed through your Google account — Mission Control never holds a password
            for you.
          </span>
        </div>
        <div className="flex flex-col items-center gap-4 sm:items-start">
          <span className="w-full text-center text-sm text-text-primary sm:w-auto sm:text-left">
            Log out of this device
          </span>
          <Button variant="secondary" className="w-full sm:w-fit" onClick={onSignOut}>
            Log Out
          </Button>
        </div>
      </div>
    </section>
  );
}
